/**
 * BonsBulkActionBanner — Bandeau contextuel qui s'affiche quand ≥3 bons attendent
 * une décision, avec CTA rapide pour ouvrir la modale "Régulariser en masse".
 *
 * Se masque automatiquement si count < 3 pour ne pas polluer la vue au quotidien.
 */
import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Zap } from "lucide-react";

const BonsBulkActionBanner = ({
  count = 0,
  total = 0,
  formatPrice = (v) => Number(v || 0).toLocaleString("fr-FR"),
  onOpenBulk,
  scopeLabel = "bons",
  minCount = 3,
  dataTestId = "bons-bulk-banner",
}) => {
  if (!count || count < minCount) return null;
  return (
    <div
      className="rounded-lg border border-amber-500/40 bg-gradient-to-r from-amber-950/30 via-amber-900/20 to-slate-900/40 p-2.5 flex items-center justify-between gap-2 flex-wrap"
      data-testid={dataTestId}
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <div className="w-9 h-9 rounded-full bg-amber-500/20 border border-amber-500/50 flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-4 h-4 text-amber-300" />
        </div>
        <div className="min-w-0">
          <p className="text-amber-100 text-[13px] font-bold leading-tight">
            {count} {scopeLabel} en attente de votre décision
          </p>
          <p className="text-amber-300/80 text-[11px] tabular-nums">
            Montant cumulé (prix normal) : <b className="text-amber-100">{formatPrice(total)} F</b>
          </p>
        </div>
      </div>
      {onOpenBulk && (
        <Button
          size="sm"
          onClick={onOpenBulk}
          className="bg-amber-600 hover:bg-amber-700 text-white h-8 text-[11.5px] font-bold flex-shrink-0"
          data-testid={`${dataTestId}-open`}
        >
          <Zap className="w-3.5 h-3.5 mr-1" /> Régulariser tout…
        </Button>
      )}
    </div>
  );
};

export default BonsBulkActionBanner;
